<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    },
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    data() {
      this.buildData();
    }
  },
  mounted() {
    this.buildData()
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    // 生成数据
    buildData() {
      var doneValue = this.data.doneValue
      var undoneValue = this.data.undoneValue
      if (!doneValue || !undoneValue) {
        return
      }
      var columLabel = ['正常', '超速'];
      var columName = this.data.labels
      var columnValue = [];
      var arrData = [];

      for (var i = 0; i < columLabel.length; i++) {
        arrData = [];
        for (var j = 0; j < columName.length; j++) {
          if (i === 0) {
            arrData.push(doneValue[j]);
          } else {
            arrData.push(undoneValue[j]);
          }
        }
        // eslint-disable-next-line no-eval
        columnValue.push(eval('(' + ("{'name':'" + columLabel[i] + "','type':'bar','data':[" + arrData + ']}') + ')'));
      }
      this.buildChart(columLabel, columName, columnValue);
    },
    // 生成图形
    buildChart(columLabel, columName, columnValue) {
      var that = this
      if (that.chart) {
        that.chart.dispose()// 销毁
      }
      that.chart = echarts.init(document.getElementById(that.id));

      var yJson = {}
      if (that.iFMaxValue()) {
        yJson = {
          min: 0,
          minInterval: 1,
          type: 'value',
          max: 4
        }
      } else {
        yJson = {
          min: 0,
          minInterval: 1,
          type: 'value'
        }
      }
      var option = {
        color: ['#68E6C1', '#F56C6C'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: columLabel
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '12%',
          containLabel: true
        },
        xAxis: {
          min: 0,
          type: 'category',
          data: columName
        },
        yAxis: yJson,
        // dataZoom: [{
        //   type: 'inside',
        //   start: 80,
        //   end: 100,
        //   minSpan: 21
        // }],
        series: columnValue
      }

      that.chart.setOption(option);
    },
    getMaxVal() {
      var that = this
      var maxVal = 0
      if (that.data.maxValue) {
        maxVal = that.data.maxValue
      }
      maxVal += 1
      // 如果是单数
      if (maxVal % 2 !== 0) {
        maxVal += 1
      }
      if (maxVal < 4) {
        maxVal = 4
      }
      return maxVal
    },
    iFMaxValue() {
      var that = this
      var flag = true
      if (that.data.maxValue) {
        if (that.data.maxValue > 4) {
          flag = false
        }
      }
      return flag
    },
    reloadSize() {
      var that = this
      if (that.id && document.getElementById(that.id)) {
        if (that.chart) {
          that.chart.resize()
        }
      }
    }
  }
};
</script>
